import { Star } from "lucide-react";
import { DoodleCalendar, DoodleBolt, FloatingDoodle } from "./Doodles";
import { useInViewOnce } from "@/hooks/useInViewOnce";
import { useLanguage } from "@/contexts/LanguageContext";

const TestimonialsSection = () => {
  const { ref, isInView } = useInViewOnce();
  const { t } = useLanguage();

  const testimonials = [
    {
      name: "Sarah van der Berg",
      role: t("landing.testimonial1_role"),
      content: t("landing.testimonial1"),
      rating: 5,
    },
    {
      name: "Mark de Vries",
      role: t("landing.testimonial2_role"),
      content: t("landing.testimonial2"),
      rating: 5,
    },
    {
      name: "Lisa Jansen",
      role: t("landing.testimonial3_role"),
      content: t("landing.testimonial3"),
      rating: 5,
    },
  ];

  return (
    <section id="testimonials" className="relative py-24 bg-background overflow-hidden">
      {/* Doodle decorations */}
      <div className="pointer-events-none absolute inset-0">
        <FloatingDoodle delay={0.5} duration={4} y={6}>
          <DoodleCalendar className="absolute top-16 right-[10%] text-accent/15" />
        </FloatingDoodle>
        <FloatingDoodle delay={1.5} duration={5}>
          <DoodleBolt className="absolute bottom-20 left-[8%] text-primary/12" />
        </FloatingDoodle>
      </div>

      <div className="container relative mx-auto px-4">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-wider text-primary">{t("landing.testimonials_label")}</span>
          <h2 className="mt-3 text-4xl font-bold text-foreground">
            {t("landing.testimonials_title")}
          </h2>
        </div>

        <div ref={ref} className="mx-auto mt-16 grid max-w-6xl gap-8 md:grid-cols-3">
          {testimonials.map((testimonial, i) => (
            <div
              key={testimonial.name}
              className="rounded-xl border border-border bg-card p-6 shadow-card"
              style={{
                opacity: isInView ? 1 : 0,
                transform: isInView ? "translateY(0)" : "translateY(20px)",
                transition: `opacity 0.4s ease-out ${i * 0.1}s, transform 0.4s ease-out ${i * 0.1}s`,
              }}
            >
              <div className="mb-3 flex gap-1">
                {Array.from({ length: testimonial.rating }).map((_, j) => (
                  <Star key={j} className="h-4 w-4 fill-accent text-accent" />
                ))}
              </div>
              <p className="text-sm leading-relaxed text-muted-foreground">"{testimonial.content}"</p>
              <div className="mt-4 border-t border-border pt-4">
                <p className="text-sm font-semibold text-card-foreground">{testimonial.name}</p>
                <p className="text-xs text-muted-foreground">{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
